import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import VueClickAway from 'vue3-click-away';
import dealActionEnd from '../adaf-deal-actions-end';
import dealActionExtends from '../adaf-deal-actions-extend';
import AdafLayout from './AdafLayout.vue';

export const initAdaf = () => {
  if (!document.getElementById('adaf-app')) {
    return;
  }

  const app = createApp(AdafLayout);
  const pinia = createPinia();
  dealActionEnd();
  dealActionExtends();

  app.config.compilerOptions.whitespace = 'preserve';
  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  const routes = [
    {
      path: '/organization/business_input/:month',
      name: 'adaf',
      props: (route) => ({
        month: route.params.month,
      }),
      component: AdafLayout,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.use(VueClickAway);
  app.use(pinia);
  app.mount('#adaf-app');
};
